module.exports = {"name":"xterm.fullscreen","main":"fullscreen.js","private":true}


//////////////////
// WEBPACK FOOTER
// ./~/xterm/lib/addons/fullscreen/package.json
// module id = 12
// module chunks = 0